module.exports = __webpack_public_path__ + "static/media/email_512.9b32a494.png";